module.exports = __webpack_public_path__ + "img/katarina_events_7.5eb59d7e.jpg";